import React from 'react'
import { Field } from 'redux-form';
import { Item, Input, painel } from 'scorpion-core';

import EditorCodigo from '../../editor/EditorCodigo'
function componentRelEspelho(comp, dados) {
    return painel([
        [{ style: "cellTitulo", text: comp.label }], [{ style: "cellValor", text: dados ? dados[comp.field] : "" }]
    ], { widths: ['*'] })

}

function logica(atualValues, props) {
    let v = parseFloat(atualValues.areaAplicacao) * parseFloat(atualValues.dose)

    if (isNaN(v)) {
        return "";
    }
    return v;
}

function component(item, propsG) {
    let v = "";
    let valores=null;
    if (propsG) {
        const { atualValues } = propsG;
         valores = atualValues;
        if (item.field.startsWith('DebugValues') && atualValues && atualValues.DebugValues) {
            valores = atualValues.DebugValues;
        }       
    }

    return <Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} placeholder={item.label} disabled={true} component={(props) => {
            const { input: { value, onChange } } = props;            
            if (valores) {           
                let conteudoAjustado = "logica(valores,propsG,value);"
                conteudoAjustado += item.logica;    
                try {
                    v = eval(conteudoAjustado);
                } catch (error) {
                    console.log('error', error);
                }
                if (v !== value) {    
                    if (item.guardaValor) {
                        onChange(v)
                    }
    
                }
            }

            return <Input {...props} input={{ ...props.input, value: v || value }} />
        }}  {...item.propsadd} />
    </Item>
}

const modelo = {
    typeComponente: "ViewInputLogico",
    field: "valor",
    label: "Valor",
    guardaValor: true,
    desativado: true,
    logica: `function logica(atualValues, propsG, value) {
        let v = parseFloat(atualValues.areaAplicacao) * parseFloat(atualValues.dose)
    
        if (isNaN(v)) {
            return "";
        }
        return v;
    }`

}

const ViewInputLogico = {
    typeComponente: "ViewInputLogico",
    configView: {
        nome: "Campo View Logico",
        modelo,
        editores: {
            logica: EditorCodigo,
        },
    },
    componentRelEspelho,
    component
}

export default ViewInputLogico;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/ViewInputLogico/index.js